// vue
import { createApp } from "vue";
import App from "./App.vue";
// pinia
import { createPinia } from "pinia";
// global styling
import "@/styles/global-styling.scss";
// vuetify
import { createVuetify } from "vuetify";
import { de, en } from "vuetify/locale";

import deDe from "dayjs/locale/de";
import enUs from "dayjs/locale/en";
import DayJsAdapter from "@date-io/dayjs";

// mdi
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

const pinia = createPinia();
const app = createApp(App);
const vuetify = createVuetify({
  defaults: {
    VSelect: {
      variant: "solo-filled",
    },
    VTextfield: {
      variant: "solo-filled",
    },
    VField: {
      variant: "solo-filled",
    },
    VCombobox: {
      variant: "solo-filled",
    },
  },
  date: {
    adapter: DayJsAdapter,
    locale: { de: deDe, en: enUs },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  locale: {
    locale: "de",
    fallback: "en",
    messages: { de, en },
  },
  theme: {
    themes: {
      dark: {
        dark: true,
        colors: {
          surface: "#212529",
          primary: "#e50043",
          error: "#e50043",
        },
        variables: {
          "surface-light": "#323539",
          "system-bar-background": "#323539",
        },
      },
      light: {
        dark: false,
        colors: {
          primary: "#e50043",
          surface: "#f0f2f5",
          error: "#e50043",
        },
        variables: {},
      },
    },
    defaultTheme: "light",
  },
});

app.use(pinia);
app.use(vuetify);

app.mount("#app");
